import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ReportListPanel, ReportListSider } from 'views/index';
import {
  tryFetchDashboardFolders,
  tryFetchReportFolders,
  resetStore
} from '../flow/actions';

const defaultProps = {};
const propTypes = {};

class ReportList extends Component {
  componentDidMount() {
    this.props.tryFetchReportFolders();
    this.props.tryFetchDashboardFolders();
  }

  componentWillUnmount() {
    this.props.resetStore();
  }

  render() {
    return (
      <div>
        <ReportListSider />
        <ReportListPanel />
      </div>
    );
  }
}

const mapStateToProps = () => ({});
const mapDispatchToProps = {
  tryFetchReportFolders,
  tryFetchDashboardFolders,
  resetStore
};
ReportList.defaultProps = defaultProps;
ReportList.propTypes = propTypes;
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReportList);



// WEBPACK FOOTER //
// ./src/views/ReportList/container/index.jsx